(function () {
    'use strict';

    const toggle = document.querySelector('.navbar-toggler');
    const mobileNav = document.getElementById('primary-nav');

    if (toggle && mobileNav) {
        toggle.addEventListener('click', function () {
            const isOpen = mobileNav.hasAttribute('hidden') === false;
            if (isOpen) {
                mobileNav.setAttribute('hidden', '');
                toggle.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-label', 'Open menu');
                document.body.classList.remove('has-mobile-nav-open');
            } else {
                mobileNav.removeAttribute('hidden');
                toggle.setAttribute('aria-expanded', 'true');
                toggle.setAttribute('aria-label', 'Close menu');
                document.body.classList.add('has-mobile-nav-open');
            }
        });
    }

    // Footer accordion (phones only, CSS hides the toggles from md up)
    document.querySelectorAll('.ft-toggle').forEach(function (button) {
        button.addEventListener('click', function () {
            const group = button.closest('.ft-group');
            const isOpen = group.classList.toggle('is-open');
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    });

    const header = document.getElementById('site-header');
    if (header) {
        let lastY = window.scrollY;
        window.addEventListener('scroll', function () {
            const y = window.scrollY;
            header.classList.toggle('is-scrolled', y > 8);
            lastY = y;
        }, { passive: true });
    }
})();
